import React from "react";
import { getRandomDog } from "./DogSvgs";
import "./ErrorPage.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  handleRedirect = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = "/authentication/split/login";
  };

  render() {
    if (this.state.hasError) {
      const RandomDog = getRandomDog();

      return (
        <div className="error-page">
          <div className="error-page__card">
            <div className="error-page__dog-container">
              <RandomDog />
            </div>

            <div className="error-page__code">Oops</div>
            <h1 className="error-page__title">Algo salió mal</h1>
            <p className="error-page__message">
              La aplicación encontró un error inesperado. Puedes intentar volver al inicio de sesión.
            </p>

            <button onClick={this.handleRedirect} className="error-page__btn">
              Ir al inicio de sesión
            </button>

            <div className="error-page__footer">
              QuroReports &bull; Sistema de reportes y análisis
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
